import {SET_USER_ONBOARDING_COMPLETE, SET_USER_ONBOARDING_PATHINDEX} from 'actions/types';

var onboardingInitialState = {onboardingComplete: false, pathIndex:-1}; 
export default (state = onboardingInitialState, action) => {
    switch(action.type) {
        case SET_USER_ONBOARDING_COMPLETE: 
            return {...state, onboardingComplete:true, pathIndex:-1};
        case SET_USER_ONBOARDING_PATHINDEX: 
            return {...state, pathIndex:action.pathIndex};
        default: 
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/onboarding.js